export default `
query ServiceFrequencies($serviceId: String!) {
  serviceFrequencies(serviceId: $serviceId) {
    id
    description
  }
}
`
